import { render, staticRenderFns } from "./sign-manage.vue?vue&type=template&id=2c2004c8&scoped=true&"
import script from "./sign-manage.vue?vue&type=script&lang=js&"
export * from "./sign-manage.vue?vue&type=script&lang=js&"
import style0 from "./sign-manage.vue?vue&type=style&index=0&id=2c2004c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2004c8",
  null
  
)

export default component.exports